import { render } from "./AddProjectView.vue?vue&type=template&id=1bdc69ee&scoped=true"
import script from "./AddProjectView.vue?vue&type=script&lang=js"
export * from "./AddProjectView.vue?vue&type=script&lang=js"

import "./AddProjectView.vue?vue&type=style&index=0&id=1bdc69ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdc69ee"]])

export default __exports__